import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';
import TicketStack from 'components/dashboard/EntriesAndStats/TicketStack';
import { GameType } from '@daymade/common-lib/dbEnums';
import { IEntryLine } from 'types/Draws';
import RoundedButton from 'components/RoundedButton';
import { useState } from 'react';

const entries: IEntryLine[] = [
  {
    type: GameType.LOTTERY,
    main: [1, 2, 3, 4],
    bonus: [5],
  },
  {
    type: GameType.LOTTERY,
    main: [22, 33, 44, 55],
    bonus: [8],
  },
];

const ComponentPreview = () => {
  const [expanded, setExpanded] = useState(false);
  return (
    <AboutUsModule background={'grey'} withNoPadding>
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">TicketStack</h3>
        <p>
          A ticket stack. It fills its container. It scales the size of the font
          with the available width of the component. By default, it will use a
          loading skeleton. Most of the examples below turn off the loading
          skeleton
        </p>
        <p> It can start initially expanded and hide the expansion button</p>
        <div style={{ width: 240 }}>
          <TicketStack entries={entries} expanded hideExpandButton />
        </div>
        <p> The component can also require the user to open it</p>

        <div style={{ width: 240 }}>
          <TicketStack entries={entries} withLoadingSkeleton={false} />
        </div>
        <div style={{ width: 300 }}>
          <TicketStack entries={entries} withLoadingSkeleton={false} />
        </div>
        <div style={{ width: 360 }}>
          <TicketStack entries={entries} withLoadingSkeleton={false} />
        </div>
        <div style={{ width: 500 }}>
          <TicketStack entries={entries} withLoadingSkeleton={false} />
        </div>
        <div style={{ width: 800 }}>
          <TicketStack entries={entries} withLoadingSkeleton={false} />
        </div>
        <div>
          <TicketStack entries={entries} withLoadingSkeleton={false} />
        </div>
        <p>The expansion can also be controlled externally</p>
        <div style={{ width: 240 }}>
          <RoundedButton mini onClick={() => setExpanded((x) => !x)}>
            Expand/collapse
          </RoundedButton>
          <TicketStack
            entries={entries}
            expanded={expanded}
            hideExpandButton
            withLoadingSkeleton={false}
          />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Ticket Stack',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
